<!--
+------------------------------------------------------------------+
| Author: Jeffrey Thümann                                          |
| Component: ContactPage                                           |
| Section: views/info                                              |
| Purpose: Contact route with communication details and form entry.|
+------------------------------------------------------------------+
-->
<template>
    <div class="ContactPage_wrapper wrapper">
        <div>
            <h1>{{ $t('contactPage.title') }}</h1>
            <p class="subtitle">{{ $t('contactPage.subtitle') }}</p>
        </div>
        <StoryCard :imageSrc="imageSrc" :contactForm="true" :cover="true" />
    </div>
</template>

<script>
import StoryCard from '../../components/StoryCard.vue';
const imageSrc = require('@/assets/jeffreythumann-8.jpg');
import { applyGenericSeo, applyBreadcrumbSeo } from '@/utils/seoUtils';

export default {
    name: "ContactPage",
    components: {
        StoryCard
    },
    data() {
        return {
            imageSrc
        };
    },
    mounted() {
        const title = this.$t('contactPage.seoTitle');
        const description = this.$t('contactPage.seoDescription');
        // Zorg dat de image een absolute URL is:
        const image = "https://sejarah-thumann.online/img/jeffreythumann-8.jpg";
        const url = window.location.href;

        applyGenericSeo({ title, description, image, url }, { includeTwitter: true });
        applyBreadcrumbSeo([{ name: this.$t('nav.home'), url: 'https://sejarah-thumann.online/' }, { name: this.$t('contactPage.title'), url: 'https://sejarah-thumann.online/contact' }]);
    }
};
</script>

<style scoped>
.ContactPage_wrapper {
    padding: var(--page-padding);
    min-height: calc(100vh - 106px - 516px);
    display: flex;
    flex-direction: column;
    gap: 96px;
}

h1,
p {
    text-align: center;
}

.subtitle {
    margin-top: 16px;
    margin-bottom: 0;
}

@media (max-width: 860px) {
    .ContactPage_wrapper {
        padding: var(--page-padding-mobile);
        gap: 72px;
    }
}
</style>
